import React, { useState, useEffect } from "react";
import { AttributeTitle } from "components/attributes/compare-table/attribute-title";
import { useTask } from "shared/hooks/use-task";
import { brandVerifiedAttributeStatus, brandVerifiedAttributeClasses } from "../attributes/lib/constants";
import { DisplayValues } from "./bv-qa-attributes-display-value";
import { removeAttrEntry, setPendingAttrEntry, setRejectedAttrEntry } from "./lib/attr-list";

const STATUS_TO_CLASS = {
    [brandVerifiedAttributeStatus.AutoAccepted]: brandVerifiedAttributeClasses.AUTO_ACCEPTED,
    [brandVerifiedAttributeStatus.Accepted]: brandVerifiedAttributeClasses.ACCEPTED,
    [brandVerifiedAttributeStatus.Rejected]: brandVerifiedAttributeClasses.REJECTED,
    [brandVerifiedAttributeStatus.Pending]: brandVerifiedAttributeClasses.PENDING,
};

export const BVQaAttributeRow = ({
    attr,
    roleLabels,
    gridTemplate,
    onUpdateAttribute,
    viewAllAttributes,
    onAttrList,
    refreshAttributeGroups,
    isCompleted,
}) => {
    const { task } = useTask();
    const approvalStatus = attr.additionalInfo?.approvalStatus;
    const isSupplierAttribute = attr.additionalInfo?.isSupplierAttribute;
    const isAutoAccepted = approvalStatus === brandVerifiedAttributeStatus.AutoAccepted;
    const hideAttribute = viewAllAttributes ? !viewAllAttributes : isAutoAccepted;
    const [status, setStatus] = useState(STATUS_TO_CLASS[approvalStatus] ?? brandVerifiedAttributeClasses.PENDING);

    useEffect(() => {
        switch (approvalStatus) {
            case brandVerifiedAttributeStatus.AutoAccepted:
            case brandVerifiedAttributeStatus.Accepted:
                setStatus(STATUS_TO_CLASS[approvalStatus]);
                onAttrList(removeAttrEntry(attr.uuid));

                return;
            case brandVerifiedAttributeStatus.Rejected:
                setStatus(brandVerifiedAttributeClasses.REJECTED);
                onAttrList(
                    setRejectedAttrEntry({
                        uuid: attr.uuid,
                        sortGroupName: attr.sortGroup?.name,
                        isSupplierAttribute,
                    })
                );

                return;
            default:
                setStatus(brandVerifiedAttributeClasses.PENDING);
                onAttrList(setPendingAttrEntry(attr.uuid));
        }
    }, [approvalStatus, attr.uuid, isSupplierAttribute, attr.sortGroup?.name, onAttrList]);

    if (hideAttribute) {
        return null;
    }

    return (
        <div
            key={attr.key}
            id={attr.key}
            className={`product-compare-row -add-padding ${status}`}
            style={gridTemplate}
        >
            <AttributeTitle
                title={attr.name}
                attr={attr}
                codingWipKey={task.context.codingWipKey}
                isCompleted={task.isCompleted}
                isBrandVerified={true}
            />
            {roleLabels.map((role, index) => (
                <DisplayValues
                    key={`AIF_${attr.uuid}_${role.label}_ref${index}`}
                    task={task}
                    role={role}
                    attr={attr}
                    status={status}
                    onStatusChange={setStatus}
                    onUpdateAttribute={onUpdateAttribute}
                    onAttrList={onAttrList}
                    refreshAttributeGroups={refreshAttributeGroups}
                    isCompleted={isCompleted}
                />
            ))}
        </div>
    );
};
